import { Skeleton } from '@fe-learner-common';
import { useConfigContext } from '@fe-core';

const BradcrumbSkeleton = () => (
  <div className="lf:flex lf:flex-1 lf:items-center lf:px-3 lf:pb-6">
    <Skeleton type="text" className="lf:mx-4 lf:my-2 lf:h-[16px] lf:w-[100px]" />
    <Skeleton type="text" className="lf:mx-4 lf:my-2 lf:h-[16px] lf:w-[150px]" />
  </div>
);

export const DetailsPageSkeleton = () => {
  const { config } = useConfigContext();
  return (
    <>
      {!config.webfeatures?.['nextgenui-default'] && (
        <Skeleton
          type="text"
          className="lf:h-[40px] lf:w-full lf:rounded-none lf:bg-prominence-50"
        />
      )}
      <div className="lf:flex lf:flex-1 lf:bg-neutral-200">
        <div className="lf:l-page lf:2xl:container">
          <BradcrumbSkeleton />

          <div className="lf:flex lf:flex-col lf:gap-8 lf:lg:flex-row lf:lg:gap-16">
            <div className="lf:aspect-video lf:w-full lf:animate-pulse lf:rounded-xl lf:bg-neutral-400 lf:object-cover lf:lg:mx-3 lf:lg:max-w-[320px]" />
            <div className="lf:flex lf:flex-1 lf:flex-col lf:gap-6 lf:lg:px-4">
              <Skeleton type="title" className="lf:h-[44px] lf:w-[300px]" />
              <Skeleton type="text" />
              <Skeleton type="button" className="lf:mt-auto" />
            </div>
          </div>
        </div>
      </div>
      <div className="lf:lg:l-page lf:flex-1 lf:2xl:container">
        <div className="lf:flex lf:flex-col lf:gap-8 lf:lg:flex-row lf:lg:gap-x-16">
          <div className="lf:flex lf:w-full lf:flex-row lf:gap-3 lf:overflow-x-auto lf:px-6 lf:py-4 lf:text-neutral-500 lf:lg:mx-3 lf:lg:w-[320px] lf:lg:min-w-[320px] lf:lg:flex-col lf:lg:gap-2 lf:lg:overflow-visible lf:lg:p-0">
            <Skeleton type="button" className="lf:w-full" />
            <Skeleton type="button" className="lf:w-full" />
            <Skeleton type="button" className="lf:w-full" />
            <Skeleton type="button" className="lf:w-full" />
          </div>

          <div className="lf:flex lf:flex-1 lf:flex-col lf:gap-y-6 lf:px-3 lf:pb-6 lf:md:gap-y-4 lf:md:pb-0 lf:lg:px-0 ">
            <Skeleton type="text" className="lf:mx-4 lf:h-[30px] lf:w-[200px]" />
          </div>
        </div>
      </div>
    </>
  );
};
